import { render, staticRenderFns } from "./StudentInvoice.vue?vue&type=template&id=7149f4d4&scoped=true&"
import script from "./StudentInvoice.vue?vue&type=script&lang=js&"
export * from "./StudentInvoice.vue?vue&type=script&lang=js&"
import style0 from "./StudentInvoice.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./StudentInvoice.vue?vue&type=style&index=1&id=7149f4d4&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7149f4d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
